import * as MSAL from '@citrite/msal-browser';
import { trackAnalyticsEvent } from 'analytics';
import { environment } from 'Environment/Environment';
import { isNativeClient } from 'Environment/launchResource/device';
import { AADSsoEventPayload } from 'Environment/msal/aadSSOEventPayload';
import {
	getUpnOrAuthAliasForCurrentUser,
	wsuiAuthEnvironment,
} from 'Environment/msal/clientInfoUtils';
import { CtxStoreTicket } from 'staticPages/scripts/ctxStoreTicketUtils';

export const setAuthorizationCode = (aadAuthCode: MSAL.AADAuthCodeType) =>
	MSAL.setAuthorizationCode(aadAuthCode);

const onPerformAuthorization = async (
	authorizationProps: MSAL.MSALAuthorizationProps
) => {
	if (typeof environment.performAuthorizationV2 === 'function') {
		return await environment.performAuthorizationV2(JSON.stringify(authorizationProps));
	}
	return await environment.performAuthorization(JSON.stringify(authorizationProps));
};

const onAADResponse = (authResult: MSAL.AADAuthResult) =>
	environment.setAADResponse(JSON.stringify(authResult));

const onAADError = (error: MSAL.AADErrorResult) => {
	trackAnalyticsEvent(AADSsoEventPayload.tokenError());
	environment.setAADError(JSON.stringify(error));
};

const getInteractionType = (): MSAL.ctxAADInteractionType => {
	if (!isNativeClient()) {
		return MSAL.ctxAADInteractionType.REDIRECT_TO_CTX_HTTPS;
	} else if (
		environment.nativeCapabilities?.functions?.includes('performAuthorizationV2')
	) {
		return MSAL.ctxAADInteractionType.REDIRECT_TO_CTX_CUSTOM_SCHEME;
	} else {
		return MSAL.ctxAADInteractionType.MS_AAD_HTTPS_INTERCEPTION;
	}
};

export const initMsalSdk = () => {
	const initConfig: MSAL.InitConfig = {
		supportsInteractiveAuthOnly: environment.supportsInteractiveAuthOnly,
		interactionType: getInteractionType(),
		onPerformAuthorization,
		onAADResponse,
		onAADError,
		environment: wsuiAuthEnvironment(),
		getCtxStoreTicket: async () => {
			return await CtxStoreTicket.request();
		},
	};
	MSAL.initMsalSdk(initConfig);
};

export const startAADTokenFlow = (authInfo: MSAL.AuthInfoWithCnf) => {
	authInfo.loginHint = getUpnOrAuthAliasForCurrentUser();
	trackAnalyticsEvent(AADSsoEventPayload.tokenRequested());
	MSAL.startAADTokenFlow(authInfo);
};
